// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"af6d9830","401":"efc32400","455":"843bed3e","977":"a40a744f","997":"1a84ba16"}[chunkId] + ".chunk.js";
};